<template>
  <!-- Handles all links sent by Firebase -->
  <div>
    <ProgressLoader v-if="!doneLoading" />
    <ResetPassword :actionCode="actionCode" v-if="type == 'resetPassword'" />
    <VerifyEmail :actionCode="actionCode" v-if="type == 'verifyEmail'" />
    <InvalidLink
      v-if="doneLoading && type !== 'resetPassword' && type !== 'verifyEmail'"
    />
  </div>
</template>

<script>
import ProgressLoader from "@/components/shared/ProgressLoader";
import ResetPassword from "./ResetPassword.vue";
import VerifyEmail from "./VerifyEmail.vue";
import InvalidLink from "./InvalidLink.vue";
export default {
  components: {
    ProgressLoader,
    ResetPassword,
    VerifyEmail,
    InvalidLink,
  },
  data() {
    return {
      doneLoading: false,
      type: "",
      actionCode: "",
    };
  },
  methods: {
    getParameterByName(name) {
      const urlParams = new URLSearchParams(window.location.search);
      const myParam = urlParams.get(name);
      return myParam;
    },
  },
  mounted() {
    // Get the action to complete.
    this.type = this.getParameterByName("mode");
    // Get the one-time code from the query parameter.
    this.actionCode = this.getParameterByName("oobCode");
    this.doneLoading = true;
  },
  created() {},
};
</script>